// SPDX-License-Identifier: AGPL-3.0-or-later

import type {CosmeticAssetDataResponse} from '@fluxer/schema/src/domains/cosmetics/CosmeticResponseSchemas';

interface WornAvatarCosmetics {
	avatarDecoration: CosmeticAssetDataResponse | null;
	avatarUltra: CosmeticAssetDataResponse | null;
}

// One decoration at a time on the avatar: accounts that put on both before the server kept one show the ultra only
// where it is drawn, and keep the frame where it is not, until their next change of either slot clears the frame.
export function shownAvatarDecoration(
	user: WornAvatarCosmetics,
	ultraDrawn: boolean = user.avatarUltra != null,
): CosmeticAssetDataResponse | null {
	return ultraDrawn ? null : user.avatarDecoration;
}
